import Swipeable from 'react-swipeable';
import styled from 'styled-components';

const SwipeableContainer = styled(Swipeable)`
  display: flex;
  flex-direction: column;
  background: #282828;
  padding: 1em 0;
  max-width: 30em;
  max-height: 100%;
  letter-spacing: 0.3em;
`;

export default SwipeableContainer;
